import React from "react";
import { ReactComponent as NavbarLogo } from "../assets/images/navbar/navbar-logo .svg";
import Select from "react-select";


const Navbar = () => {
  const options = [
    { value: "po", label: "PO file translator" },
    { value: "xliff", label: "XLIFF file translator" }
  ];
  const onSelectChange = (value) => {
    if (value?.value == "po") {
      window.location.href = " https://www.textunited.com/po-free-translator/ ";
    }
    if (value?.value == "xliff") {
      window.location.href = " https://www.textunited.com/xliff-free-translator/ ";
    }
  };
  const customStyles = {
    container: (provided) => ({
      ...provided,
      width: "300px",
      fontFamily: "Gilroy SemiBold",
    }),
    option: (provided, state) => ({
      ...provided,
      color: state.isSelected ? "white" : "black",
      backgroundColor: state.isSelected ? "#251cc9" : "white",

    }),
    control: (provided) => ({
      ...provided,
      marginTop: "0%",
      width: "300px"
    }),

  };
  return (
    <div className="navbar">
      <NavbarLogo  className="navbar-logo" onClick={() => (window.location.href="https://www.textunited.com/")}/>
      <Select options={options} placeholder={"JSON file translator"} onChange={onSelectChange} styles={customStyles} />
    </div>
  );
};

export default Navbar;
